module.exports = [{path: "/404/", info: null, isAsync: true, comp: function load404jsAsync(cb) {
            require.ensure(["./404.js"], function (err) {
              cb(require("./404.js").default)
            }, "404.js")
          }},
{path: "/", info: null, isAsync: true, comp: function loadHomejsAsync(cb) {
            require.ensure(["./Home.js"], function (err) {
              cb(require("./Home.js").default)
            }, "Home.js")
          }},
{path: "/docs/", info: null, isAsync: true, comp: function loadDocsjsAsync(cb) {
            require.ensure(["./Docs.js"], function (err) {
              cb(require("./Docs.js").default)
            }, "Docs.js")
          }},
{path: "/docs/form/", info: null, isAsync: true, comp: function loaddocsFormjsAsync(cb) {
            require.ensure(["./docs/Form.js"], function (err) {
              cb(require("./docs/Form.js").default)
            }, "docs/Form.js")
          }},
{path: "/docs/optional/", info: null, isAsync: true, comp: function loaddocsOptionaljsAsync(cb) {
            require.ensure(["./docs/Optional.js"], function (err) {
              cb(require("./docs/Optional.js").default)
            }, "docs/Optional.js")
          }},
{path: "/docs/reform-context/", info: null, isAsync: true, comp: function loaddocsReformContextjsAsync(cb) {
            require.ensure(["./docs/ReformContext.js"], function (err) {
              cb(require("./docs/ReformContext.js").default)
            }, "docs/ReformContext.js")
          }},
{path: "/docs/themes/", info: null, isAsync: true, comp: function loaddocsThemesjsAsync(cb) {
            require.ensure(["./docs/Themes.js"], function (err) {
              cb(require("./docs/Themes.js").default)
            }, "docs/Themes.js")
          }},
{path: "/docs/validations/", info: null, isAsync: true, comp: function loaddocsValidationsjsAsync(cb) {
            require.ensure(["./docs/Validations.js"], function (err) {
              cb(require("./docs/Validations.js").default)
            }, "docs/Validations.js")
          }},
{path: "/docs/wrap-input/", info: null, isAsync: true, comp: function loaddocsWrapInputjsAsync(cb) {
            require.ensure(["./docs/WrapInput.js"], function (err) {
              cb(require("./docs/WrapInput.js").default)
            }, "docs/WrapInput.js")
          }},
{path: "/getting-started/", info: null, isAsync: true, comp: function loadGettingStartedjsAsync(cb) {
            require.ensure(["./GettingStarted.js"], function (err) {
              cb(require("./GettingStarted.js").default)
            }, "GettingStarted.js")
          }},
{path: "/recipes/", info: null, isAsync: true, comp: function loadRecipesjsAsync(cb) {
            require.ensure(["./Recipes.js"], function (err) {
              cb(require("./Recipes.js").default)
            }, "Recipes.js")
          }}]


//////////////////
// WEBPACK FOOTER
// ./web_loaders/routes-loader.js!./src/pages/Home.js
// module id = 632
// module chunks = 0